$(".gallery-tab__label").click(function() {
  $(".gallery-tab__label").removeClass("is-active");
  $(this).addClass("is-active");
});
